import '@descope-ui/descope-text';
import '@vaadin/icons';
import '@vaadin/icon';

import { componentName, RecoveryCodesClass } from './RecoveryCodesClass';

customElements.define(componentName, RecoveryCodesClass);

export { RecoveryCodesClass, componentName };
